<template>
    <div class="--dots d-flex align-content-space-between flex-wrap">
        <div class="d-flex justify-space-between ">
            <span></span>
            <span></span>
        </div>
        <div class="d-flex justify-space-between">
            <span></span>
            <span></span>
        </div>
    </div>
</template>
<script>
    export default {
        name: "FourDots"
    }
</script>
<style lang="scss">
    .--dots{
        width: 11px;
        height: 11px;
        div{
            flex: 0 0 100%;
        }
        span{
            width: 3px;
            height: 3px;
            border-radius: 50%;
            background: #233a75;
        }
    }
</style>